export const DEFAULT_CROSS_PORTAL_LINK = "https://www.profielbestellen.nl";
export const ASSETS_BASE_PATH = "assets/";